// component vs. container https://medium.com/@dan_abramov/smart-and-dumb-components-7ca2f9a7c7d0
import { connect } from 'react-redux';
import { formatPostLists } from '~/queue/util';
// load the presentational component
import { actions as composerPopoverActions } from '~/composer-popover';
import { actions } from './reducer';
import PendingTiktok from './components/PendingTiktok';

// default export = container
export default connect(
  (state, ownProps) => {
    const { profileId } = ownProps;
    const currentProfile = state.pendingTiktok.byProfileId[profileId];
    const profileData = state.profileSidebar.profiles.find(
      (p) => p.id === profileId
    );

    if (currentProfile && profileData) {
      return {
        header: currentProfile.header,
        loading: currentProfile.loading,
        loadingMore: currentProfile.loadingMore,
        moreToLoad: currentProfile.moreToLoad,
        page: currentProfile.page,
        items: formatPostLists({
          isManager: profileData.isManager,
          weekStartsOnMonday: state.user.week_starts_monday,
          profileService: profileData.service,
          profileTimezone: profileData.timezone,
          scheduleSlotsEnabled: false,
          posts: currentProfile.posts,
          orderBy: 'due_at',
          sortOrder: 'desc',
        }),
        total: currentProfile.total,
        profileServiceType: profileData.service_type,
        profileService: profileData.service,
        showComposer: state.composerPopover.showComposer,
        isManager: state.profileSidebar.selectedProfile.isManager,
        showAnalyzeBannerAfterFirstPost:
          state.profileSidebar.selectedProfile.shouldHideAdvancedAnalytics,
        isDisconnectedProfile:
          state.profileSidebar.selectedProfile.isDisconnected,
        analyzeCrossSale:
          state.user.analyzeCrossSale && state.organizations.selected?.isOwner, // Analyze doesn't support team members
        hasFirstCommentFlip:
          state.organizations.selected?.hasFirstCommentFeature,
        hasCampaignsFeature: state.organizations.selected?.hasCampaignsFeature,
        has30DaySentPostsLimitFeature:
          state.organizations.selected?.has30DaySentPostsLimitFeature,
        hasAnalyticsOnPosts: state.organizations.selected?.hasAnalyticsOnPosts,
        hasTwitterImpressions:
          state.organizations.selected?.hasTwitterImpressions,
      };
    }
    return {};
  },
  (dispatch, ownProps) => ({
    onShareAgainClick: ({ post }) => {
      dispatch(composerPopoverActions.handleShareAgainClick(post.id));
    },
    onConfirmDismissComposer: () => {
      dispatch(composerPopoverActions.hideComposer());
    },
    onComposerCreateSuccess: () => {
      dispatch(composerPopoverActions.hideComposer());
    },
    onCampaignTagClick: (campaignId) => {
      dispatch(
        actions.handleCampaignTagClick({
          campaignId,
        })
      );
    },
    fetchPendingTiktokPosts: () => {
      dispatch(
        actions.fetchPendingTiktokPosts({
          profileId: ownProps.profileId,
        })
      );
    },
  })
)(PendingTiktok);

// export reducer, actions and action types
export { default as reducer, actions, actionTypes } from './reducer';
export { default as middleware } from './middleware';
